import productService from '../../services/productService';

// Action types
export const FETCH_PRODUCTS_START = "FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_ERROR = "FETCH_PRODUCTS_ERROR";

export const FETCH_PRODUCT_START = "FETCH_PRODUCT_START";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_ERROR = "FETCH_PRODUCT_ERROR";

export const FETCH_CATEGORIES_START = "FETCH_CATEGORIES_START";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR";

// Action creators
const fetchProductsStart = () => ({
  type: FETCH_PRODUCTS_START
});

const fetchProductsSuccess = products => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: products
});

const fetchProductsError = error => ({
  type: FETCH_PRODUCTS_ERROR,
  payload: error
});

const fetchProductStart = () => ({
  type: FETCH_PRODUCT_START
});

const fetchProductSuccess = product => ({
  type: FETCH_PRODUCT_SUCCESS,
  payload: product
});

const fetchProductError = error => ({
  type: FETCH_PRODUCT_ERROR,
  payload: error
});

const fetchCategoriesStart = () => ({
  type: FETCH_CATEGORIES_START
});

const fetchCategoriesSuccess = categories => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: categories
});

const fetchCategoriesError = error => ({
  type: FETCH_CATEGORIES_ERROR,
  payload: error
});

// Async action creators
export const fetchProducts = (filters = {}) => {
  return async dispatch => {
    dispatch(fetchProductsStart());
    try {
      const products = await productService.getAllProducts(filters);
      dispatch(fetchProductsSuccess(products));
    } catch (error) {
      dispatch(fetchProductsError(error.message));
    }
  };
};

export const fetchProductById = (id) => {
  return async dispatch => {
    dispatch(fetchProductStart());
    try {
      const product = await productService.getProductById(id);
      dispatch(fetchProductSuccess(product));
    } catch (error) {
      dispatch(fetchProductError(error.message));
    }
  };
};

export const fetchCategories = () => {
  return async dispatch => {
    dispatch(fetchCategoriesStart());
    try {
      const categories = await productService.getCategories();
      dispatch(fetchCategoriesSuccess(categories));
    } catch (error) {
      dispatch(fetchCategoriesError(error.message));
    }
  };
};

export const searchProducts = (query) => {
  return async dispatch => {
    dispatch(fetchProductsStart());
    try {
      const products = await productService.searchProducts(query);
      dispatch(fetchProductsSuccess(products));
    } catch (error) {
      dispatch(fetchProductsError(error.message));
    }
  };
};

// Temporary fallback for development with local data
export const fetchProductsFromLocal = products => {
  return dispatch => {
    dispatch(fetchProductsSuccess(products));
  };
};
